import React from "react";
import Hero from "../components/Hero";
import Work from "../components/Work";
import Tools from "../components/Tools";
import Contact from "../components/Contact";

function Home() {
  return (
    <main>
      {/* Hero */}
      <section id="hero">
        <Hero />
      </section>
      {/* Work */}
      <section id="work">
        <Work />
      </section>
      {/* Tools */}
      <section id="tools">
        <Tools />
      </section>
      {/* Contact */}
      <section id="contact">
        <Contact />
      </section>
    </main>
  );
}

export default Home;
